import type { Difficulty } from '@/types';

/**
 * `difficulty`/`topic` backendga (GET /problems) so'rov parametri sifatida boradi.
 * `search` esa faqat joriy sahifa natijalari ustida client-side filtr —
 * backend hali full-text qidiruvni qo'llab-quvvatlamaydi.
 */
export interface Filters {
  search: string;
  difficulty: Difficulty | 'all';
  topic: string | 'all';
}

export const EMPTY_FILTERS: Filters = {
  search: '',
  difficulty: 'all',
  topic: 'all',
};
